module.exports = __webpack_public_path__ + "img/1528676335.3fcfcfdf.jpg";